import { useMemo, useState } from "react";

import { Image } from "semantic-ui-react";

import Viewer from "react-viewer";

type DisplayContentImageProps = {
  id: number;
  isMediaViewer?: boolean;
  isMobile: boolean;
  src: string;
  onLoadImage?: (id: number) => void;
};

const DisplayContentImage = (props: DisplayContentImageProps) => {
  const [image, setImage] = useState<string | null>(null);

  const images = useMemo(() => (image ? [{ src: image }] : []), [image]);

  return (
    <>
      <Image
        style={{ cursor: "pointer" }}
        src={props.src}
        onClick={() => {
          if (!props.isMobile) {
            if (props.isMediaViewer) {
              setImage(props.src);
            } else {
              window.open(props.src);
            }
          }

          // if (typeof window.iosNative !== "undefined") {
          //   window.iosNative.consoleLog("onClick");
          //   window.iosNative.saveImage(props.message.content_file);
          // }
        }}
        onLoad={() => props.onLoadImage?.(props.id)}
      />

      {!!image && (
        <Viewer
          className="chat-box-content-image-viewer"
          attribute={false}
          defaultScale={1.25}
          images={images}
          loop={false}
          maxScale={2.4}
          minScale={1.25}
          showTotal={false}
          visible={!!image}
          zoomSpeed={0.3}
          disableMouseZoom
          downloadInNewWindow
          noNavbar
          onClose={() => {
            setImage(null);
          }}
          onMaskClick={(e) => {
            const target = e.target as HTMLDivElement;

            if (target.className === "react-viewer-canvas") {
              setImage(null);
            }
          }}
          customToolbar={(toolbars) =>
            toolbars.filter((toolbar) => toolbar.key === "zoomIn" || toolbar.key === "zoomOut")
          }
          // container={document.getElementById("container")}
        />
      )}
    </>
  );
};

export default DisplayContentImage;
